<script setup lang="ts">
import { computed, defineAsyncComponent, type Component } from 'vue'

export interface UiCountryFlagProps {
    /**
     * ISO2 country code (e.g., 'US', 'GB', 'CA')
     */
    countryCode: string
    /**
     * Alt text for accessibility
     */
    alt?: string
}

const props = withDefaults(defineProps<UiCountryFlagProps>(), {
    alt: undefined,
})

const FlagComponent = computed<Component>(() => {
    const code = props.countryCode.toUpperCase()
    
    return defineAsyncComponent({
        loader: () => import(`../assets/countries/flags/${code}.svg`),
        errorComponent: {
            template: '<span class="inline-block">🏳️</span>',
        },
        delay: 0,
        timeout: 3000,
    })
})

const altText = computed(() => props.alt || `${props.countryCode} flag`)
</script>

<template>
    <component 
        :is="FlagComponent" 
        :aria-label="altText"
        role="img"
        class="ui-country-flag"
    />
</template>

<style scoped>
.ui-country-flag {
    display: inline-block;
    vertical-align: middle;
}
</style>

